export enum PageId {
  start = 'start',
  finish = 'finish',
  raceResult = 'race-result',
  fenseResult = 'fense-result',
  createRace = 'create-race',
  fenceResultAudience = 'fence-result-audience',
  trackMap = 'track-map',
  clientEvents = 'client-events',
  adminHome = 'admin-home',
  manager = 'manager',
}
